import React, { useState } from 'react';
import { NewTripRequest } from '../../types';

interface StepProps {
  formData: NewTripRequest;
  setFormData: React.Dispatch<React.SetStateAction<NewTripRequest>>;
}

const StepLocations: React.FC<StepProps> = ({ formData, setFormData }) => {
  const [mustSeeInput, setMustSeeInput] = useState('');

  const addMustSeePlace = () => {
    if (mustSeeInput.trim() && !formData.mustSeePlaces.includes(mustSeeInput.trim())) {
      setFormData(prev => ({
        ...prev,
        mustSeePlaces: [...prev.mustSeePlaces, mustSeeInput.trim()]
      }));
      setMustSeeInput('');
    }
  };

  const removeMustSeePlace = (place: string) => {
    setFormData(prev => ({
      ...prev,
      mustSeePlaces: prev.mustSeePlaces.filter(p => p !== place)
    }));
  };

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      
      {/* Route Info */}
      <div className="space-y-4">
        <h3 className="text-lg font-medium text-gray-900">Planned Route (Optional)</h3>
        <p className="text-sm text-gray-500">If you have specific starting or ending points for your journey.</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
                <label htmlFor="startingLocation" className="block text-sm font-medium text-gray-700">Starting Location</label>
                <div className="relative">
                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                        📍
                     </div>
                    <input
                        type="text"
                        id="startingLocation"
                        value={formData.startingLocation || ''}
                        onChange={(e) => setFormData(prev => ({ ...prev, startingLocation: e.target.value }))}
                        className="block w-full pl-10 rounded-lg border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 py-2.5"
                        placeholder="e.g. JFK Airport"
                    />
                </div>
            </div>

            <div className="space-y-2">
                <label htmlFor="endingLocation" className="block text-sm font-medium text-gray-700">Ending Location</label>
                <div className="relative">
                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                        🏁
                     </div>
                    <input
                        type="text"
                        id="endingLocation"
                        value={formData.endingLocation || ''}
                        onChange={(e) => setFormData(prev => ({ ...prev, endingLocation: e.target.value }))}
                        className="block w-full pl-10 rounded-lg border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 py-2.5"
                        placeholder="e.g. London Heathrow"
                    />
                </div>
            </div>
        </div>
      </div>

      <div className="border-t border-gray-100 pt-4"></div>

      {/* Must See Places */}
      <div className="space-y-4">
        <h3 className="text-lg font-medium text-gray-900">Must-See Places</h3>
        <p className="text-sm text-gray-500">Any specific landmarks or attractions you don't want to miss?</p>
        
        <div className="flex gap-2">
            <input
                type="text"
                value={mustSeeInput}
                onChange={(e) => setMustSeeInput(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addMustSeePlace())}
                placeholder="e.g. Eiffel Tower, Grand Canyon..."
                className="flex-1 rounded-lg border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
            />
            <button
                type="button"
                onClick={addMustSeePlace}
                disabled={!mustSeeInput.trim()}
                className="px-6 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800 disabled:opacity-50 font-medium"
            >
                Add
            </button>
        </div>

        {/* List of Must Sees */}
        {formData.mustSeePlaces.length > 0 && (
            <div className="flex flex-wrap gap-3 mt-4">
                {formData.mustSeePlaces.map((place, index) => (
                    <div key={index} className="flex items-center gap-2 bg-primary-50 text-primary-800 px-3 py-1.5 rounded-full border border-primary-100 shadow-sm animate-in zoom-in-50 duration-200">
                        <span className="font-medium">{place}</span>
                        <button
                            type="button"
                            onClick={() => removeMustSeePlace(place)}
                            className="w-5 h-5 flex items-center justify-center rounded-full hover:bg-primary-200 text-primary-600 transition-colors"
                        >
                            ×
                        </button>
                    </div>
                ))}
            </div>
        )}
        
        {formData.mustSeePlaces.length === 0 && (
            <div className="text-center py-8 bg-gray-50 rounded-lg border border-dashed border-gray-300 text-gray-400">
                No must-see places added yet.
            </div>
        )}
      </div>

    </div>
  );
};

export default StepLocations;

